import React from 'react';

/** @internal */
export var deleteIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 1.5C10.5401 1.5 10.8837 1.65212 11.1204 1.83623C11.3714 2.0314 11.5635 2.31164 11.7059 2.64392C11.7565 2.76218 11.7988 2.88218 11.834 3H8.166C8.20119 2.88218 8.24346 2.76218 8.29415 2.64392C8.43655 2.31164 8.62863 2.0314 8.87957 1.83623C9.11627 1.65212 9.45985 1.5 10 1.5ZM7.13185 3C7.37361 1.96559 8.0587 0.5 10 0.5C11.9413 0.5 12.6264 1.96559 12.8682 3H15.5C16.8807 3 18 4.11929 18 5.5V6V7H17V18C17 19.1046 16.1046 20 15 20H5C3.89543 20 3 19.1046 3 18V7H2V6V5.5C2 4.11929 3.11929 3 4.5 3H7.13185ZM13 4H11.9999H8.00008H7H4.5C3.67157 4 3 4.67157 3 5.5V6H4H16H17V5.5C17 4.67157 16.3284 4 15.5 4H13ZM4 18V7H16V18C16 18.5523 15.5523 19 15 19H5C4.44772 19 4 18.5523 4 18Z"
}));